import { render, staticRenderFns } from "./sportbook-category.vue?vue&type=template&id=2cfb6585&scoped=true&"
import script from "./sportbook-category.vue?vue&type=script&lang=js&"
export * from "./sportbook-category.vue?vue&type=script&lang=js&"
import style0 from "./sportbook-category.vue?vue&type=style&index=0&id=2cfb6585&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb6585",
  null
  
)

export default component.exports